import { Form, FormProps } from "antd";
import { INITIAL_SEARCH_FORM_VALUES, SearchFormInputs } from "../../../constants";
import { useNavigate } from "react-router-dom";
import { FC, ReactNode, useState } from "react";
import { simpleHash } from "src/utility/security";
import { prepareSearchObject } from "../utils";
import { track } from "@amplitude/analytics-browser";

export const SearchForm: FC<{
  render: (props: { values?: { journeyType?: number }; errorFields: string[] }) => ReactNode;
  onFinish?: (values: SearchFormInputs) => void;
  initialValues?: SearchFormInputs;
} & FormProps> = ({
  render,
  initialValues = INITIAL_SEARCH_FORM_VALUES,
  onFinish,
  onFinishFailed,
  ...props
}) => {
  const [form] = Form.useForm();
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const navigate = useNavigate();
  const correctedInitialValues = prepareSearchObject(initialValues);
  const handleSubmit = (values: SearchFormInputs) => {
    const finalValues = { ...values, rooms: form.getFieldValue("rooms") ?? values.rooms };
    const searchString = JSON.stringify(finalValues);
    const { hash } = simpleHash(searchString);
    localStorage.setItem(hash, searchString);
    track("Search Submitted", { values: finalValues });
    navigate(`/hotel/${hash}?t=${Date.now()}`); //TODO: Change path to hotels
    onFinish?.(finalValues);
  };

  const handleFail = async () => {
    try {
      await form.validateFields();
      setErrorFields([]);
    } catch (errorInfo: any) {
      const actualErrors = errorInfo.errorFields.map((f: any) => f.name[0]);
      setErrorFields(actualErrors);
      onFinishFailed?.(errorInfo);
    }
  };
  const handleChangeValues = async ()=>{
    try {
      await form.validateFields({validateOnly:true});
      setErrorFields([]);
    } catch (errorInfo: any) {
      const values = form.getFieldsValue();
      const nonRequiredErrors = errorInfo.errorFields
        .filter((f: any) => {
          const value = values[f.name[0]];
          return value !== undefined && value !== null && value !== '';
        })
        .map((f: any) => f.name[0]);
      setErrorFields(nonRequiredErrors);
    }
  }

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      onFinishFailed={handleFail}
      initialValues={correctedInitialValues}
      onValuesChange={handleChangeValues}
      className="w-full"
      {...props}
    >
      {render({ errorFields })}
    </Form>
  );
};
